
function Anji1({ className }) {
    return (
        <div className={className}>
            <img src='/imgs/_icons/anji1.svg' alt=""/>
        </div>
    )
}

export default Anji1